import PropTypes from "prop-types";
import { useSelector } from "react-redux";

function ProductWithTestCode({ dragFlag, selectedStudy, datum, draggableColumns, draggedColumnIndex }) {
    const productsTestCodeMapData = useSelector((state) => state.studyDataStore.productTestCodeMap);
    const proTitle = dragFlag ? `${draggableColumns?.[draggedColumnIndex].title}__${draggableColumns?.[draggedColumnIndex].coreDataId}` : `${datum.title}__${datum.coreDataId}`;
    const proTestCode = productsTestCodeMapData[proTitle];
    let title = "";
    let secondPart = "";
    let studyTitle = "";
    const isDrag = dragFlag;
    const dragData = draggableColumns?.[draggedColumnIndex];
    const isPro = isDrag ? dragData?.title.includes(proTestCode) : datum.title.includes(proTestCode);
    const currentTitle = isDrag ? dragData?.title : datum.title;
    const coreDataId = isDrag ? dragData?.coreDataId : datum.coreDataId;

    if (isPro) {
        title = currentTitle.split("/")[0];
        secondPart = currentTitle.split("/")[1];
    } else {
        title = currentTitle;
        secondPart = proTestCode;
    }

    studyTitle = selectedStudy?.find((study) => study.id === coreDataId)?.study_reference__title;

    return (
        <>
            {title} / <span style={{ color: "#6f42c1" }}>{secondPart}</span> / {studyTitle}
        </>
    );
}

ProductWithTestCode.propTypes = {
    dragFlag: PropTypes.bool,
    selectedStudy: PropTypes.array,
    datum: PropTypes.object,
    draggableColumns: PropTypes.array,
    draggedColumnIndex: PropTypes.number,
};

export default ProductWithTestCode;
